(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('custom-accordion').then(() => {
    class FooterAccordion extends CustomAccordion {
      constructor() {
        super();
        this.wasDesktop = window.matchMedia('(min-width: 750px)').matches;
        this.updateOpenState();
        window.addEventListener('resizeend', this.updateOpenState.bind(this));
      }

      updateOpenState() {
        if (window.matchMedia('(min-width: 750px)').matches) {
          this.detailsElem.open = true;
          this.summaryElem.setAttribute('tabindex', '-1');
          this.summaryElem.classList.add('pointer-events-none');
          this.wasDesktop = true;
        } else if (this.wasDesktop) {
          this.detailsElem.open = false;
          this.summaryElem.removeAttribute('tabindex');
          this.summaryElem.classList.remove('pointer-events-none');
          this.wasDesktop = false;
        }
      }
    }

    customElements.define('footer-accordion', FooterAccordion);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
      this.headerBounds = {};

      this.setHeaderHeight();
      this.setHeaderHeightLive();

      window.addEventListener('resizeend', this.setHeaderHeight.bind(this));
      window.addEventListener('resizeend', this.setHeaderHeightLive.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.lastScrollTrigger = 0;
      this.scrollThreshold = 50;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });

      this.searchButton = this.querySelector('.header__icon--search');
      if (this.searchButton) {
        this.searchButton.addEventListener('click', this.searchButtonClick.bind(this));
      }

      this.createObserver();
    }

    searchButtonClick() {
      this.preventHide = true;
      requestAnimationFrame(() => { this.preventHide = false; });
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    setHeaderHeightLive(event, zero) {
      document.documentElement.style.setProperty('--header-height-live', `${zero ? 0 : this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      requestAnimationFrame(() => {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

        // Only trigger actions if the scroll has changed by at least the threshold value
        if (Math.abs(scrollTop - this.lastScrollTrigger) < this.scrollThreshold) return;

        const scrollDifference = scrollTop - this.currentScrollTop;
        // Handle scrolling classes based on 50px sensitivity
        if (scrollDifference > 50 && this.pauseScrollListen !== true) {
          // Scrolling down
          this.pauseScrollListen = true;
          this.header.classList.add('scrolling-down');
          this.header.classList.remove('scrolling-up');
          setTimeout(() => {
            this.setHeaderHeightLive();
            this.pauseScrollListen = false;
          }, 320);
        } else if (scrollDifference < -50 && this.pauseScrollListen !== true) {
          // Scrolling up
          this.pauseScrollListen = true;
          this.header.classList.add('scrolling-up');
          this.header.classList.remove('scrolling-down');
          setTimeout(() => {
            this.setHeaderHeightLive();
            this.pauseScrollListen = false;
          }, 320);
        }

        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          // Main logic for scrolling down
          this.header.classList.add('scrolled-past-header');
          if (this.preventHide) return;
          requestAnimationFrame(this.hide.bind(this));
        } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          // Main logic for scrolling up
          this.header.classList.add('scrolled-past-header');
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          } else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        } else if (scrollTop <= this.headerBounds.top) {
          // Reset at the top
          this.header.classList.remove('scrolled-past-header');
          this.header.classList.remove('scrolling-down');
          this.header.classList.remove('scrolling-up');
          requestAnimationFrame(this.reset.bind(this));
          setTimeout(() => {
            this.setHeaderHeightLive();
          }, 320);
        }

        this.currentScrollTop = scrollTop;
        this.lastScrollTrigger = scrollTop; // Update the last scroll position that triggered an action
      });
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
      this.setHeaderHeightLive(null, true);
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      this.setHeaderHeightLive();
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close?.(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mc-uthyrning"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(scope){
    scope.querySelectorAll('[data-pm-motion-toggle]').forEach(function(button){
      if(button.dataset.pmReady)return;
      var tape=button.closest('[data-pm-motion]');
      if(!tape)return;
      button.dataset.pmReady='1';
      button.addEventListener('click',function(){
        var paused=button.getAttribute('aria-pressed')!=='true';
        button.setAttribute('aria-pressed',String(paused));
        button.setAttribute('aria-label',paused?'Starta textraden':'Pausa textraden');
        tape.dataset.paused=String(paused);
      });
    });
  }
  init(document);
  if(!window.pmTapeLifecycle){
    window.pmTapeLifecycle=true;
    document.addEventListener('shopify:section:load',function(event){init(event.target);});
    document.addEventListener('DOMContentLoaded',function(){init(document);});
  }
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mc-vardering"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(scope){
    scope.querySelectorAll('[data-pm-motion-toggle]').forEach(function(button){
      if(button.dataset.pmReady)return;
      var tape=button.closest('[data-pm-motion]');
      if(!tape)return;
      button.dataset.pmReady='1';
      button.addEventListener('click',function(){
        var paused=button.getAttribute('aria-pressed')!=='true';
        button.setAttribute('aria-pressed',String(paused));
        button.setAttribute('aria-label',paused?'Starta textraden':'Pausa textraden');
        tape.dataset.paused=String(paused);
      });
    });
  }
  init(document);
  if(!window.pmTapeLifecycle){
    window.pmTapeLifecycle=true;
    document.addEventListener('shopify:section:load',function(event){init(event.target);});
    document.addEventListener('DOMContentLoaded',function(){init(document);});
  }
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pm-category-cards"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('pm-category-cards')) {
  customElements.define('pm-category-cards', class extends HTMLElement {
    connectedCallback() {
      this._frame = requestAnimationFrame(() => this.setup());
    }
    disconnectedCallback() {
      cancelAnimationFrame(this._frame);
      if (this._cleanup) this._cleanup();
    }
    setup() {
      if (this._cleanup) this._cleanup();
      const rail = this.querySelector('.pmcr2__rail');
      const track = this.querySelector('.pmcr2__track');
      if (!rail || !track || !this.isConnected) return;
      const controller = new AbortController();
      const listen = (target, name, fn, options = {}) => target.addEventListener(name, fn, { ...options, signal: controller.signal });
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const limit = () => Math.max(0, rail.scrollWidth - rail.clientWidth);
      const clamp = value => Math.max(0, Math.min(limit(), value));
      let drag = null;
      let ignoreClickUntil = 0;
      const update = () => rail.classList.toggle('is-scrollable', limit() > 1);
      const finish = event => {
        if (!drag || (event && event.pointerId !== drag.id)) return;
        const completed = drag;
        drag = null;
        if (rail.hasPointerCapture(completed.id)) rail.releasePointerCapture(completed.id);
        rail.classList.remove('is-dragging');
        if (completed.moved) ignoreClickUntil = performance.now() + 500;
      };
      listen(rail, 'pointerdown', event => {
        ignoreClickUntil = 0;
        if (event.pointerType !== 'mouse' || event.button !== 0 || !event.isPrimary || limit() <= 1) return;
        drag = { id: event.pointerId, x: event.clientX, y: event.clientY, left: rail.scrollLeft, moved: false };
      });
      listen(rail, 'pointermove', event => {
        if (!drag || event.pointerId !== drag.id) return;
        const dx = event.clientX - drag.x;
        const dy = event.clientY - drag.y;
        if (!drag.moved) {
          if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return;
          if (Math.abs(dy) > Math.abs(dx)) { finish(event); return; }
          drag.moved = true;
          rail.setPointerCapture(drag.id);
          rail.classList.add('is-dragging');
        }
        event.preventDefault();
        rail.scrollLeft = clamp(drag.left - dx);
      });
      listen(rail, 'pointerup', finish);
      listen(rail, 'pointercancel', finish);
      listen(rail, 'lostpointercapture', finish);
      listen(rail, 'pointerleave', event => { if (drag && !drag.moved) finish(event); });
      listen(rail, 'dragstart', event => event.preventDefault());
      listen(rail, 'click', event => {
        if (event.detail > 0 && performance.now() < ignoreClickUntil) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      }, { capture: true });
      listen(rail, 'keydown', event => {
        if (event.target !== rail || event.altKey || event.ctrlKey || event.metaKey) return;
        const first = track.firstElementChild;
        if (!first) return;
        const pitch = first.getBoundingClientRect().width + (parseFloat(getComputedStyle(track).columnGap) || 0);
        let destination;
        if (event.key === 'ArrowRight') destination = rail.scrollLeft + pitch;
        if (event.key === 'ArrowLeft') destination = rail.scrollLeft - pitch;
        if (event.key === 'Home') destination = 0;
        if (event.key === 'End') destination = limit();
        if (destination === undefined) return;
        event.preventDefault();
        rail.scrollTo({ left: clamp(destination), behavior: reducedMotion.matches ? 'instant' : 'smooth' });
      });
      const observer = window.ResizeObserver ? new ResizeObserver(update) : null;
      if (observer) observer.observe(rail);
      else listen(window, 'resize', update, { passive: true });
      listen(this, 'shopify:block:select', event => {
        const item = event.target.closest('.pmcr2__item');
        if (!item || !this.contains(item)) return;
        const left = rail.scrollLeft + item.getBoundingClientRect().left - rail.getBoundingClientRect().left - 8;
        rail.scrollTo({ left: clamp(left), behavior: 'instant' });
      });
      update();
      this._cleanup = () => {
        finish();
        controller.abort();
        if (observer) observer.disconnect();
        rail.classList.remove('is-scrollable', 'is-dragging');
        this._cleanup = null;
      };
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pm-club-membership"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(scope){
    scope.querySelectorAll('[data-pm-motion-toggle]').forEach(function(button){
      if(button.dataset.pmReady)return;
      var tape=button.closest('[data-pm-motion]');
      if(!tape)return;
      button.dataset.pmReady='1';
      button.addEventListener('click',function(){
        var paused=button.getAttribute('aria-pressed')!=='true';
        button.setAttribute('aria-pressed',String(paused));
        button.setAttribute('aria-label',paused?'Starta textraden':'Pausa textraden');
        tape.dataset.paused=String(paused);
      });
    });
  }
  init(document);
  if(!window.pmTapeLifecycle){
    window.pmTapeLifecycle=true;
    document.addEventListener('shopify:section:load',function(event){init(event.target);});
    document.addEventListener('DOMContentLoaded',function(){init(document);});
  }
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pm-mc-formedling"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(scope){
    scope.querySelectorAll('[data-pm-motion-toggle]').forEach(function(button){
      if(button.dataset.pmReady)return;
      var tape=button.closest('[data-pm-motion]');
      if(!tape)return;
      button.dataset.pmReady='1';
      button.addEventListener('click',function(){
        var paused=button.getAttribute('aria-pressed')!=='true';
        button.setAttribute('aria-pressed',String(paused));
        button.setAttribute('aria-label',paused?'Starta textraden':'Pausa textraden');
        tape.dataset.paused=String(paused);
      });
    });
  }
  init(document);
  if(!window.pmTapeLifecycle){
    window.pmTapeLifecycle=true;
    document.addEventListener('shopify:section:load',function(event){init(event.target);});
    document.addEventListener('DOMContentLoaded',function(){init(document);});
  }
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pm-mc-transport"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('pm-mc-transport')) {
  customElements.define('pm-mc-transport', class extends HTMLElement {
    connectedCallback() {
      if (this.abortController) return;
      this.abortController = new AbortController();
      const signal = this.abortController.signal;
      this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.manuallyPaused = false;
      this.inView = true;
      this.toggleControl = this.querySelector('[data-toggle-motion]');
      this.querySelector('[data-destinations]').hidden = false;
      this.setAttribute('data-ready', '');
      this.querySelectorAll('[data-select-city]').forEach(button => {
        button.addEventListener('click', () => {
          const city = button.dataset.selectCity;
          this.querySelectorAll('[data-select-city]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
          this.querySelectorAll('[data-route]').forEach(item => item.classList.toggle('is-active', item.dataset.route === city));
          this.querySelectorAll('[data-city]').forEach(item => item.classList.toggle('is-active', item.dataset.city === city));
          this.querySelector('[data-destination]').textContent = button.textContent;
        }, { signal });
      });
      this.toggleControl.addEventListener('click', () => {
        this.manuallyPaused = !this.manuallyPaused;
        this.updateMotion();
      }, { signal });
      this.motionQuery.addEventListener('change', () => this.updateMotion(), { signal });
      document.addEventListener('visibilitychange', () => this.updateMotion(), { signal });
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          this.inView = entries[0].isIntersecting;
          this.updateMotion();
        }, { threshold: 0.05 });
        this.observer.observe(this.querySelector('.pmtr-map'));
      }
      this.updateMotion();
    }
    updateMotion() {
      const disabled = this.dataset.motion === 'false' || this.motionQuery.matches;
      this.toggleControl.hidden = disabled;
      this.toggleAttribute('data-paused', disabled || this.manuallyPaused || !this.inView || document.hidden);
      this.toggleControl.setAttribute('aria-pressed', String(this.manuallyPaused));
      this.toggleControl.querySelector('[data-motion-label]').textContent = this.manuallyPaused ? this.dataset.play : this.dataset.pause;
    }
    disconnectedCallback() {
      this.abortController?.abort();
      this.abortController = null;
      this.observer?.disconnect();
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pm-mc-workshop-list"] && !Shopify.designMode) return;
  try {
    
(function(){
 function init(root){
  if(root.dataset.pmCatalogReady)return;
  var cards=Array.from(root.querySelectorAll('[data-pmws-card]'));
  var buttons=Array.from(root.querySelectorAll('[data-pmws-filter]'));
  var search=root.querySelector('[data-pmws-search]');
  var status=root.querySelector('[data-pmws-status]');
  var empty=root.querySelector('[data-pmws-no-results]');
  var pager=root.querySelector('[data-pmws-pager]');
  if(!search||!cards.length)return;
  root.dataset.pmCatalogReady='1';
  var category=cards.some(function(card){return card.dataset.category==='service';})?'service':'all';
  var page=0,pageSize=6;
  function normalize(value){return String(value).normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLocaleLowerCase('sv').trim();}
  var indexed=cards.map(function(card){return {card:card,text:normalize(card.querySelector('.pmws__card-copy').textContent)};});
  buttons.forEach(function(button){
   var count=cards.filter(function(card){return button.dataset.pmwsFilter==='all'||card.dataset.category===button.dataset.pmwsFilter;}).length;
   button.hidden=count===0;
   var badge=document.createElement('span');badge.className='pmws__category-count';badge.textContent=count;badge.setAttribute('aria-hidden','true');button.appendChild(badge);
   button.addEventListener('click',function(){category=button.dataset.pmwsFilter;page=0;search.value='';render();});
  });
  function render(){
   var terms=normalize(search.value).split(/\s+/).filter(Boolean);
   var matches=indexed.filter(function(item){return(category==='all'||item.card.dataset.category===category)&&terms.every(function(term){return item.text.includes(term);});}).map(function(item){return item.card;});
   page=Math.min(page,Math.max(0,Math.ceil(matches.length/pageSize)-1));
   var visible=new Set(matches.slice(page*pageSize,(page+1)*pageSize));
   cards.forEach(function(card){card.hidden=!visible.has(card);});
   root.querySelectorAll('[data-pmws-category-group]').forEach(function(group){group.hidden=!Array.from(group.querySelectorAll('[data-pmws-card]')).some(function(card){return visible.has(card);});});
   buttons.forEach(function(button){button.setAttribute('aria-pressed',String(button.dataset.pmwsFilter===category));});
   var active=buttons.find(function(button){return button.dataset.pmwsFilter===category;});
   root.querySelector('[data-pmws-result-heading]').textContent=terms.length?'Sökresultat':(active?active.childNodes[0].textContent.trim():'Tjänster');
   var from=matches.length?page*pageSize+1:0,to=Math.min((page+1)*pageSize,matches.length);
   status.textContent=matches.length?'Visar '+from+'–'+to+' av '+matches.length+' tjänster':'Inga tjänster matchar din sökning.';
   var counter=root.querySelector('[data-pmws-visible]');if(counter)counter.textContent=String(matches.length);
   empty.hidden=matches.length>0;pager.hidden=matches.length<=pageSize;
   pager.querySelector('[data-pmws-prev]').disabled=page===0;
   pager.querySelector('[data-pmws-next]').disabled=to>=matches.length;
   pager.querySelector('[data-pmws-page]').textContent='Sida '+(page+1)+' av '+Math.max(1,Math.ceil(matches.length/pageSize));
   root.querySelector('[data-pmws-clear]').hidden=!search.value;
  }
  search.addEventListener('input',function(){category='all';page=0;render();});
  root.querySelector('[data-pmws-clear]').addEventListener('click',function(){search.value='';page=0;render();search.focus();});
  root.querySelector('[data-pmws-reset]').addEventListener('click',function(){search.value='';category='all';page=0;render();search.focus();});
  function changePage(direction){page+=direction;render();status.focus({preventScroll:true});root.querySelector('[data-pmws-results]').scrollIntoView({block:'start',behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'});}
  pager.querySelector('[data-pmws-prev]').addEventListener('click',function(){changePage(-1);});
  pager.querySelector('[data-pmws-next]').addEventListener('click',function(){changePage(1);});
  render();
 }
 function scan(scope){scope.querySelectorAll('[data-pmws-ui="catalog"]').forEach(init);}
 scan(document);document.addEventListener('shopify:section:load',function(event){scan(event.target);});
})();


  } catch(e) { console.error(e); }
})();
})();
